const DEFAULTS = {
  selector: 'data-large-player',
};

export default class largePlayer {

  constructor(container, options = DEFAULTS) {
    if (!container) return;
    this.options = options;
    this.container = container;
    this.button = container.querySelector(`[${this.options.selector}-trigger]`);
    this.iframe = container.querySelector(`[${this.options.selector}-video]`);
    this.events();
  }

  /**
   * Add the click listener.
   * This also removed the button element that gets clicked.
   * @return {void}
   */
  events() {
    this.button.addEventListener('click', () => {
      this.button.remove();
      this.addVideo();
      setTimeout(() => this.removeBackground(), 1000);
    });
  }

  /**
   * Build and set the iframe src attibute.
   */
  addVideo() {
    const videoCode = this.iframe.getAttribute(`${this.options.selector}-video`);
    const origin = window.location.origin;
    this.iframe.setAttribute('src', `https://www.youtube-nocookie.com/embed/${videoCode}?rel=0&playsinline=1&autoplay=1&showinfo=0&enablejsapi=1&origin=${origin}`);
  }

  /**
   * Remove the background image to free up memory.
   * Visitor is never going to see it again.
   * @return {[type]}
   */
  removeBackground() {
    this.container.style = '';
  }

}
